(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ai-product-overview"] && !Shopify.designMode) return;
  try {
    // Above-the-fold "✦ AI Overview" anchor → activate + expand the Overview tab.
  // Smooth-scroll is handled by the existing jsScrollTo handler; this only
  // opens the tab/accordion so the overview is visible after the scroll.
  (function () {
    var pending = false; // in-flight guard so rapid clicks can't stack callbacks

    // Preferred: drive the tab through the component's own public API (single
    // source of truth) once it has lazy-loaded. Returns false if unavailable.
    function openViaComponent(tabId) {
      var comp = document.querySelector('product-description-component');
      if (!comp || typeof comp.openTab !== 'function') return false;
      comp.openTab(tabId);
      var body = comp.querySelector('#' + tabId);
      var toggle = body && body.querySelector('.jsToggleNav');
      if (toggle && !toggle.classList.contains('show')) toggle.click();
      return true;
    }

    // Guaranteed fallback: switch tabs directly against the SERVER-RENDERED
    // markup, with no dependency on the lazy component. Used when the component
    // never takes over (scroll interrupted, script fails, IO never fires).
    function openDirect(tabId) {
      var scope = document.getElementById('productDescription');
      if (!scope) return false;
      var link = scope.querySelector('.jsTabNav[href="#' + tabId + '"]');
      var body = document.getElementById(tabId);
      if (!link || !body) return false;
      scope.querySelectorAll('.jsTabNav.active').forEach(function (n) { n.classList.remove('active'); });
      scope.querySelectorAll('.tab-content--body.active').forEach(function (n) { n.classList.remove('active'); });
      link.classList.add('active');
      body.classList.add('active');
      var details = body.querySelector('.tab-content-details');
      if (details) { details.style.opacity = '1'; details.style.maxHeight = 'none'; details.classList.add('expanded'); }
      var toggle = body.querySelector('.jsToggleNav');
      if (toggle) toggle.classList.add('show');
      return true;
    }

    document.addEventListener('click', function (e) {
      var link = e.target.closest('.jsOpenOverview');
      if (!link) return;
      var tabId = link.getAttribute('data-overview-tab') || 'tabaioverview';

      // Fast path — component already upgraded on this session.
      if (openViaComponent(tabId)) return;

      // WHY: product-description-component is a <lazy-script> that only upgrades
      // when scrolled into view (IntersectionObserver). A click before that
      // upgrade used to hit `if (!comp) return` and silently no-op, leaving the
      // default-active Description tab showing instead of Overview (Brett,
      // 2026-08-03). Resolve the race with a single in-flight request: prefer
      // the component once it defines, but fall back to a direct DOM switch on a
      // bounded timeout so the click is NEVER dead.
      if (pending) return;
      pending = true;
      var settled = false;
      function finish(preferComponent) {
        if (settled) return;
        settled = true; pending = false;
        if (!(preferComponent && openViaComponent(tabId))) openDirect(tabId);
      }

      if (window.customElements && customElements.whenDefined) {
        customElements.whenDefined('product-description-component').then(function () {
          requestAnimationFrame(function () { finish(true); }); // node may swap a frame later
        });
      }
      // Fallback if the component hasn't taken over in time.
      setTimeout(function () { finish(false); }, 1200);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
